import * as React from 'react'
import classnames from 'classnames'
import { ContextStore } from './reducer'
import { ISortProps } from './interface'

interface IProps {
  onClick(item: ISortProps, line: number): void
  price: any[]
  type: string
  typeText?: string
  line?: number
}

export default function PriceInput({
  onClick,
  price = [
    {
      param: ' , ',
    },
  ],
  type = 'price',
  typeText = '万',
  line = 0
}: IProps) {

  const getValue = React.useCallback((value: string) => {
    if (type === 'price') {
      return parseInt(value, 10)
    }
    return parseFloat(parseFloat(value).toFixed(2)) || 0
  }, [type])

  const [low, setLow] = React.useState<string>('')
  const [high, setHigh] = React.useState<string>('')
  const { state, dispatch } = React.useContext(ContextStore)
  React.useEffect(() => {
    setLow(price[0].param.split(',')[0])
    const high =
      parseInt(price[0].param.split(',')[1], 10) > 0
        ? price[0].param.split(',')[1]
        : ''
    setHigh(high)
  }, [price[0].param])
  function handleClick() {
    if (errorMsg) {
      return
    }
    let text = ''
    let mLow = getValue(low || '0') || 0
    let mHigh = getValue(high || '0') || 0

    if (!mHigh && type === 'dcar_score') {
      mHigh = 5
    }

    if (!mLow && !mHigh) {
      return
    }

    if (!mLow) {
      text = `${mHigh}${typeText}以下`
    } else if (!mHigh) {
      text = `${mLow}${typeText}以上`
    } else {
      if (mHigh < mLow) {
        ;[mHigh, mLow] = [mLow, mHigh]
        setHigh(`${mHigh}`)
        setLow(`${mLow}`)
      }
      text = `${mLow}-${mHigh}${typeText}`
    }
    // 确定按钮 如果数据一样的话，就不提交
    const param = `${mLow || 0},${mHigh || -1}`;
    // 是否为已经选择的，需要转为不限
    if (type &&
      state?.[type]?.[0] &&
      param === state?.[type]?.[0]?.['param']) {
      return
    }

    onClick(
      {
        key: type,
        param: param,
        text,
      },
      line
    )
  }

  const errorMsg = React.useMemo(() => {
    if (type === 'price') {
      return ''
    }

    if (Boolean(parseFloat(low)) || Boolean(parseFloat(high))) {
      if (parseFloat(high) > 5 || parseFloat(low) > 5) {
        return '懂车分不能超过5分'
      }
      if (parseFloat(low) < 0 || parseFloat(high) < 0) {
        return '懂车分不能小于0分'
      }
      return ''
    }
    return ''
  }, [low, high])

  const isActive = React.useMemo(() => {
    return Boolean(parseFloat(low)) || Boolean(parseFloat(high))
  }, [low, high])

  return (
    <div className="inputs">
      <input
        value={low}
        type="number"
        onChange={e => {
          setLow(e.target.value)
        }}
      />
      <span className="line">-</span>
      <input
        value={high}
        type="number"
        onChange={e => {
          setHigh(e.target.value)
        }}
      />
      <span className="unit">{typeText || '万'}</span>
      {errorMsg && type === 'dcar_score' && (
        <span className="error-text">{errorMsg}</span>
      )}
      <span
        className={classnames('button', {
          active: isActive && !errorMsg
        })}
        onClick={handleClick}
      >
        确定
      </span>
      <style jsx>
        {`
          .inputs {
            position: relative;
            display: inline-block;
            border-radius: 2px;
            border: solid 0.5px #E6E8F2;
            padding-right: 50px;
            width: 168px;
          }
          .error-text{
            position: absolute;
            left: 0;
            bottom: -18px;
            font-size: 12px;
            color: #e62021;
            transform: scale(0.8);
            transform-origin: left top;
          }
          .unit{
            color:#606370;
            font-size: 12px;
          }
          .line {
            margin: 0 2px;
            color: #979aa8;
          }
          input {
            font-size: 12px;
            width: 40px;
            height: 24px;
            padding: 0 5px;
            outline: 0;
            text-align: center;
            appearance: none;
          }
          .button{
            position: absolute;
            width: 48px;
            right: -1px;
            top:-1px;
            bottom:-1px;
            text-align: center;
            line-height: 26px;
            border-top-right-radius: 2px;
            border-bottom-right-radius: 2px;
            background-color: #E6E8F2;
            font-size: 12px;
            color: rgba(0, 0, 0, 0.32);
            cursor: pointer;
          }
          .button.active{
            color:#1f2129;
            background: #ffcc32;
          }
          input::-webkit-outer-spin-button,
          input::-webkit-inner-spin-button {
            -webkit-appearance: none;
          }
          input[type='number'] {
            -moz-appearance: textfield;
          }
        `}
      </style>
    </div>
  )
}
